import axios from "axios";
import { logout } from "../utils/logout";

const api = axios.create({
  baseURL: "https://node.lcwe-lb.com/api",
  // baseURL: "http://localhost:4000/api",
  withCredentials: true, // REQUIRED for cookies
});

/* ======================
   Helper: Read Cookie
====================== */
function getCookie(name) {
  const match = document.cookie.match(
    new RegExp("(^| )" + name + "=([^;]+)")
  );
  return match ? match[2] : null;
}

/* ======================
   REQUEST INTERCEPTOR
====================== */
api.interceptors.request.use((config) => {
  const csrfToken = getCookie("csrfToken");
  const method = config.method?.toLowerCase();

  // Debug lines to add temporarily:
  console.log("ALL COOKIES AVAILABLE:", document.cookie);
  console.log("EXTRACTED CSRF TOKEN:", csrfToken);
  
  const isAuthRoute =
    config.url?.includes("/auth/login") ||
    config.url?.includes("/auth/logout");

  if (
    csrfToken &&
    !isAuthRoute &&
    ["post", "put", "patch", "delete"].includes(method)
  ) {
    config.headers["X-CSRF-TOKEN"] = csrfToken;
  }

  return config;
});

/* ======================
   RESPONSE INTERCEPTOR
====================== */
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (!error.response) {
      return Promise.reject(error);
    }

    const status = error.response.status;

    // Only handle 401
    if (status !== 401) {
      return Promise.reject(error);
    }

    const isAuthRoute =
      originalRequest.url?.includes("/auth/login") ||
      originalRequest.url?.includes("/auth/refresh") ||
      originalRequest.url?.includes("/auth/logout") ||
      originalRequest.url?.includes("/auth/me");

    // 🚫 Do NOT refresh for auth routes
    if (isAuthRoute) {
      return Promise.reject(error);
    }

    // Prevent infinite retry
    if (originalRequest._retry) {
      logout();
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      await api.post("/auth/refresh");
      return api(originalRequest);
    } catch (err) {
      logout();
      return Promise.reject(err);
    }
  }
);


export default api;
